





























































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import InvestigateApi from '@/api/investigate'
import BillApi from '@/api/bill2'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import addTaskMixin from './addTaskMixin'
const PIAO_JU_CHA_XUN = '6'

@Component({
	name: 'bill2TaskList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins, addTaskMixin) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false
	private PIAO_JU_CHA_XUN = PIAO_JU_CHA_XUN

	private taskDetailPwd(action: any) {
		return `/bill2/taskDetail/${action.orderId}/${action.taskType}`
	}
	private bosssoftTaskDetailPwd(action: any) {
		return `/bill2/bosssoftTaskDetail/${action.orderId}/${action.taskType}`
	}

	private taskEdit(action: any) {
		return `/bill2/taskEdit/${action.orderId}/${action.taskType}`
	}

	public getList() {
		return BillApi.getList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	private listResearch(row: any) {
		this.bill2Research(row, () => {
			this.getList()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree').then((res: any) => {
			this.setCompanyAsTree()
		})
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.beginTime =
			form.rangeTime &&
			form.rangeTime[0] &&
			form.rangeTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.rangeTime &&
			form.rangeTime[1] &&
			form.rangeTime[1].format('YYYY-MM-DD')
		delete form.rangeTime
		let temp =
			typeof form.company.value === 'string'
				? form.company.value.trim()
				: form.company.value
		if (temp || temp === 0) {
			form.companyId = temp
		}
		delete form.company

		return form
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
